export const PROJECT_VIABILITY = 'project_viability';

export const ECONOMIC = 'economicIndicators';
export const FINANCIAL = 'financialIndicators';
export const SOCIAL = 'socialIndicators';
